import React, { ChangeEvent, useCallback } from 'react';
import t from 'rcm-i18n'
import { CategoryData, ProductData } from './types';
import { InputTextField, RawFieldRenderer } from 'forms';
import ResultsDescription from './ResultsDescription';
import SidebarCategory from './SidebarCategory';
interface Props {
    selectedCategoryId: number;
    categories: CategoryData[];
    onCategorySelect: (categoryId: number) => void;
    onSearchTextChange: (searchText: string) => void;
    searchText: string;
    searchDescription: string;
    filteredProducts: ProductData[];
}

const Sidebar = ({
    selectedCategoryId, categories, onCategorySelect, searchText, onSearchTextChange, searchDescription, filteredProducts
}: Props) => {
    const handleSearchTextChange = useCallback((newValue) => {
        onSearchTextChange(newValue)
    }, [onSearchTextChange]);
    const handleCategorySelectChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
        onCategorySelect(parseInt(event.target.value));
    }, [onCategorySelect]);
    return <div className="all-products-sidebar">
        <ResultsDescription resultCount={filteredProducts.length} searchDescription={searchDescription} />
        <form className="all-products-sidebar-main-form">
            <div className="input-group">
                <InputTextField Renderer={RawFieldRenderer}
                    className="form-control"
                    placeholder="Search Products..."
                    value={searchText}
                    onValueChange={handleSearchTextChange}
                    debounce={300}
                />
                <span className="input-group-addon"><span className="glyphicon glyphicon-search" aria-hidden="true" /></span>
            </div>
        </form>
        <div className="all-products-mobile-category-select-wrapper">
            <select className="form-control all-products-mobile-category-select" value={selectedCategoryId} onChange={handleCategorySelectChange}>
                {categories.map(category =>
                    <option key={category.id} value={category.id}>{category.name}</option>
                )}
            </select>
        </div>
        <div className="all-products-sidebar-facets">
            <div className="all-products-sidebar-facet-header">
                {t('Categories')}
            </div>
            <ul>
                {categories.map(category =>
                    <SidebarCategory key={category.id} category={category} onCategorySelect={onCategorySelect} />
                )}
            </ul>
        </div>
    </div >
};

export default Sidebar;
